import type { UUID } from '@util/uuid';

export type PublicID<T extends string> = { __brand: T } & string;

export type TeamID = UUID<'team'>;
export const toTeamID = (str: string) => str as TeamID;

export type ProxyTeamID = UUID<'proxyTeam'>;
export const toProxyTeamID = (str: string) => str as ProxyTeamID;

export type PublicTeamID = PublicID<'publicTeamProfile'>;
export const toPublicTeamID = (str: string) => str as PublicTeamID;

export type OrgID = UUID<'organization'>;
export const toOrgID = (str: string) => str as OrgID;

export type PublicOrgID = PublicID<'publicOrganization'>;
export const toPublicOrgID = (str: string) => str as PublicOrgID;

export type UserID = UUID<'user'>;
export const toUserID = (str: string) => str as UserID;

export type EventID = UUID<'event'>;
export const toEventID = (str: string) => str as EventID;

export type LineupID = UUID<'lineup'>;
export const toLineupID = (str: string) => str as LineupID;

export type StreamID = UUID<'stream'>;
export const toStreamID = (str: string) => str as StreamID;

export type AssetID = UUID<'asset'>;
export const toAssetID = (str: string) => str as AssetID;

export type OrgEventID = UUID<'org-event'>;
export const toOrgEventID = (str: string) => str as OrgEventID;

export type MaxPrepID = UUID<'maxprep'>;
export const toMaxPrepID = (str: string) => str as MaxPrepID;

export type PlayerID = UUID<'player'>;
export const toPlayerID = (str: string) => str as PlayerID;

export type VideoClipID = UUID<'VideoClip'>;
export const toVideoClipID = (videoClipID: string) => videoClipID as VideoClipID;

export type AthleteProfileID = UUID<'AthleteProfileID'>;
export const toAthleteProfileID = (athleteProfileID: string) => athleteProfileID as AthleteProfileID;

export type WidgetID = PublicID<'widget'>;
export const toWidgetID = (id: string) => id as WidgetID;

export type AnnouncementID = UUID<'announcement'>;
export const toAnnouncementId = (id: string) => id as AnnouncementID;
